import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Card,
  Flex,
  Grid,
  Select,
  Skeleton,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
  useBreakpointValue,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import MultiDropdown from "components/common/multiDropdown/MultiDropdown";
import { routePath } from "config/pathConstant";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FaFileUpload } from "react-icons/fa";
import { HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import { addOneDayToDate } from "utils/dateUtils/dateUtils";
import CustomDateRangeMobile from "../common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "../common/CustomDateRangePicker/CustomDateRangePicker";
import Datepicker from "../common/DatePicker";
import UploadDocumentModal from "../common/UploadDocumentModal/UploadDocumentModal";
import DashboardTable from "./DashboardTable";
import DashWidget from "./element/DashWidget";
// import WorkflowTableStatus from "./FiveWorkflowTable";
import { PieChart } from "./PieChart";
import WorkflowListModal from "./WorkflowListModal";

export default function MtDashboardIndex(): JSX.Element {
  const {
    toastNotify,
    accountDetails,
    workFlowData,
    defaultAbsent,
    activeWorkflow,
    setActivePage,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    resetDates,
    selectedTransport,
    setSelectedTransport
  } = useContext(AppContext);

  const getCurrentTab = () => {
    if (accountDetails.level === "admin") {
      return 0;
    } else {
      const userLevelIndex = parseInt(accountDetails.level.split("-")[1], 10);
      return userLevelIndex - 1;
    }
  };

  const [chartData, setChartData] = useState<any>([]);
  const [approvedData, setApprovedData] = useState<any>(null);
  const [rejectedData, setRejectedData] = useState<any>(null);
  const [passedData, setPassedData] = useState<any>(null);
  const [exceptionalData, setExceptionalData] = useState<any>(null);
  const [guestHouseData, setGuestHouseData] = useState<any>(null);
  const [undefinedData, setUndefinedData] = useState<any>(null);
  const [paymentFailedData, setPaymentFailedData] = useState<any>(null);
  const [pendingData, setPendingData] = useState<any>(null);
  const [totalInvoicesCount, setTotalInvoicesCount] = useState<any>(null);
  const [initialData, setInitalialData] = useState<any>(null);
  const [globalTotalCount, setGlobalTotalCount] = useState<number | undefined>(
    undefined
  );
  const [tabIndex, setTabIndex] = useState<number>(getCurrentTab());
  const [loading, setLoading] = useState(false);
  const [searchFilters, setSearchFilters] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [transformedOptions, setTransformedOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [transformedTab, setTransformedTab] = useState<any>([]);
  const [firstTimeCall, setFirstTimeCall] = useState(1);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
  const [dateTo, setToDate] = useState(endDate);
  const [dateFrom, setFromDate] = useState(startDate);
  const [totalGroupedData, setTotalGroupedData] = useState([]);
  const [activeComponent, setActiveComponent] = useState({
    open: 0,
    status: "",
  });

  /* -------------------------------------------------------------
   *  NEW: Keep local dateFrom/dateTo in sync with global startDate/endDate
   * ------------------------------------------------------------- */
  useEffect(() => {
    setFromDate(startDate);
    setToDate(endDate);
  }, [startDate, endDate]);

  const fileInputRef = useRef<any>(null);
  const isBreakpoint = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    if (defaultAbsent === true) {
      setIsOpen(true);
    }
  }, [defaultAbsent]);

  useEffect(() => {
    sessionStorage.removeItem("documentTab");
  }, []);

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const arrangeData = (chartData: any) => {
    const statusOrder: any = {
      pending: 1,
      posted: 2,
      approved: 3,
      rejected: 4,
    };

    chartData.sort((a: any, b: any) => {
      return (
        (statusOrder[a.status] || Infinity) -
        (statusOrder[b.status] || Infinity)
      );
    });

    return chartData;
  };

  const calculatesChartData = (data: any, overrideTotal?: number) => {
    let pendingTotal = 0;
    let passedTotal = 0;
    let rejectedTotal = 0;
    let approvedTotal = 0;
    let exceptional = 0;
    let guestHouse = 0;
    let undefinedCount = 0;
    let paymentFailed = 0;

    if (data) {
      Object.keys(data).forEach((lvl) => {
        const levelData = data[lvl];
        pendingTotal += levelData?.pending || 0;
        passedTotal += levelData?.passed || 0;
        rejectedTotal += levelData?.rejected || 0;
        approvedTotal += levelData?.approved || 0;
        exceptional += levelData?.exceptional || levelData?.exception || 0;
        guestHouse += levelData?.guestHouse || 0;
        undefinedCount += levelData?.undefined || 0;
        paymentFailed += levelData?.paymentFailed || 0;
      });
    }


    let total = pendingTotal + approvedTotal + rejectedTotal + exceptional + guestHouse + undefinedCount + paymentFailed;




    const result = [
      { status: "pending", count: pendingTotal },
      { status: "exception", count: exceptional },
      { status: "approved", count: approvedTotal },
      { status: "guestHouse", count: guestHouse },
      { status: "undefined", count: undefinedCount },
      { status: "paymentFailed", count: paymentFailed },
    ];

    setApprovedData(approvedTotal);
    setPendingData(pendingTotal);
    setRejectedData(rejectedTotal);
    setPassedData(passedTotal);
    setExceptionalData(exceptional);
    setGuestHouseData(guestHouse);
    setUndefinedData(undefinedCount);
    setPaymentFailedData(paymentFailed);
    // if (workFlowData?.totalInvoice) {
    //   setTotalInvoicesCount(total);
    // }
    if (true) {
      setTotalInvoicesCount(total);
    }
    return arrangeData(result);
  };

  useEffect(() => {
    if (
      // workFlowData?.totalInvoice &&
      true &&
      !chartData.some((entry: any) => entry.status === "total")
    ) {
      let total = 0;
      total =
        (pendingData || 0) +
        (approvedData || 0) +
        (rejectedData || 0) +
        (exceptionalData || 0) +
        (guestHouseData || 0) +
        (undefinedData || 0) +
        (paymentFailedData || 0);



      setChartData((prev: any) => [
        ...prev,
        {
          status: "total",
          count: total,
        },
      ]);
    }
  }, [
    workFlowData,
    approvedData,
    pendingData,
    rejectedData,
    chartData,
    exceptionalData,
  ]);

  const handleChangeTabIndex = (index: number) => {
    setTabIndex(index);

    if ((index >= 1 || accountDetails.level !== "admin") && initialData) {
      let levelKey: string | undefined = undefined;

      if (accountDetails.level === "admin") {
        levelKey = `level-${index}`;
      } else {
        levelKey = `level-${index + 1}`;
      }

      const levelStats = initialData[levelKey] || {
        pending: 0,
        approved: 0,
        rejected: 0,
        passed: 0,
        exceptional: 0,
        guestHouse: 0,
        undefined: 0,
        paymentFailed: 0,
      };

      const pendingTotal = levelStats.pending || 0;
      const approvedTotal = levelStats.approved || 0;
      const rejectedTotal = levelStats.rejected || 0;
      const passedTotal = levelStats.passed || 0;
      const exceptional = levelStats.exceptional || 0;
      const guestHouse = levelStats.guestHouse || 0;
      const undefinedCount = levelStats.undefined || 0;
      const paymentFailed = levelStats.paymentFailed || 0;

      const result = [
        { status: "pending", count: pendingTotal },
        { status: "exception", count: exceptional },
        { status: "guestHouse", count: guestHouse },
        { status: "undefined", count: undefinedCount },
        { status: "paymentFailed", count: paymentFailed },
      ];

      result.push({ status: "approved", count: approvedTotal });

      setApprovedData(approvedTotal);
      setPendingData(pendingTotal);
      setRejectedData(rejectedTotal);
      setPassedData(passedTotal);
      setExceptionalData(exceptional);
      setGuestHouseData(guestHouse);
      setUndefinedData(undefinedCount);
      setPaymentFailedData(paymentFailed);

      if (true) {
        const total = pendingTotal + approvedTotal + rejectedTotal + exceptional + guestHouse + undefinedCount + paymentFailed;
        setTotalInvoicesCount(total);
      }

      setChartData(arrangeData(result));
    } else {
      setChartData(calculatesChartData(initialData, globalTotalCount));
    }
  };

  const calculateDateFrom = () => {
    const dateRange = workFlowData?.dateFilter?.range;
    const today = new Date();

    if (dateRange) {
      const endMonth = parseInt(dateRange.split("-")[1], 10);
      today.setMonth(today.getMonth() - endMonth);
    } else {
      today.setMonth(today.getMonth() - 6);
    }

    return today;
  };

  const handleStartDateChange = (startDate: Date) => {
    setFirstTimeCall(2);
    const newStartDate = new Date(startDate);
    newStartDate.setDate(newStartDate.getDate());
    setFromDate(newStartDate);
    setStartDate(newStartDate);
  };

  const handleEndDateChange = (endDate: Date) => {
    setEndDate(endDate);
    setToDate(endDate);
  };

  const resetFilters = () => {
    setSearchFilters([]);
    setSelectedOptions({});
    getLevelData(true);
  };

  const getLevelData = async (reset?: any) => {
    try {
      setLoading(true);
      let query: any = {
        dateTo: firstTimeCall === 1 ? dateTo : addOneDayToDate(dateTo),
        dateFrom: dateFrom,
        level: accountDetails.level,
        _id: accountDetails.user,
        company: accountDetails.company?._id || accountDetails.company,
        transportType: selectedTransport
      };

      if (reset) {
        setFirstTimeCall(1);
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate());
        query.dateTo = tomorrow;
        const newDateFrom = calculateDateFrom();
        newDateFrom.setDate(newDateFrom.getDate());
        query.dateFrom = newDateFrom;
      }

      if (
        workFlowData.dateFilter?.filterKey &&
        workFlowData.dateFilter?.filterKey?.length
      ) {
        query = { ...query, dateFilterKey: workFlowData.dateFilter?.filterKey };
      }
      const searchFilters: any = [];

      for (const key in selectedOptions) {
        if (Array.isArray(selectedOptions[key])) {
          if (selectedOptions[key].length > 0) {
            selectedOptions[key].forEach((item: any) => {
              const filterObject: any = {};
              filterObject[key] = item.value;
              searchFilters.push(filterObject);
            });
          }
        } else if (selectedOptions[key] && selectedOptions[key].value) {
          const filterObject: any = {};
          filterObject[key] = selectedOptions[key].value;
          searchFilters.push(filterObject);
        }
      }

      if (reset !== true) {
        if (searchFilters.length) {
          query = { ...query, searchFilters: searchFilters };
        }
      }
      if (activeWorkflow !== accountDetails.defaultWorkflow) {
        query = { ...query, activeWorkflow: activeWorkflow };
      }

      const response: any = await appRequest("mmtDocument", "getCount", query);

      if (response?.status === "error") {
        toastNotify({
          title: `Error getting the dashboard details`,
          message: "Something went wrong",
          type: "error",
        });
      } else {
        const data = response?.manual || response;
        if (response?.totalCount !== undefined) {
          setGlobalTotalCount(response.totalCount);
        }
        const existingLevels = new Set();
        if (Array.isArray(data)) {
          data?.forEach((item: any) => {
            if (item._id && item._id.level) {
              existingLevels.add(item._id.level);
            }
          });
          const groupedData = data?.reduce((acc: any, item: any) => {
            const key = item._id?.level?.toLowerCase();
            if (!acc[key]) {
              acc[key] = {};
            }
            if (!acc[key][item._id?.status]) {
              acc[key][item._id?.status] = 0;
            }
            acc[key][item._id?.status] += item?.count;
            return acc;
          }, {} as Record<string, Record<string, number>>);

          setChartData(calculatesChartData(groupedData, response?.totalCount));
          setInitalialData(groupedData);
        } else {
          toastNotify({
            title: `Error fetching the dashboard details`,
            message: "Something went wrong",
            type: "error",
          });
        }
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the dashboard details`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setLoading(false);
      setSearchFilters([]);
    }
  };

  async function getUsersWorkFlows(reset?: any) {
    try {
      setLoading(true);
      setLoading(true);
      let query: any = {
        dateTo: firstTimeCall === 1 ? dateTo : addOneDayToDate(dateTo),
        dateFrom: dateFrom,
        level: accountDetails.level,
        _id: accountDetails.user,
        company: accountDetails.company?._id || accountDetails.company,
        transportType: selectedTransport
      };

      if (reset) {
        setFirstTimeCall(1);
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate());
        query.dateTo = tomorrow;
        const newDateFrom = calculateDateFrom();
        newDateFrom.setDate(newDateFrom.getDate());
        query.dateFrom = newDateFrom;
      }

      if (
        workFlowData.dateFilter?.filterKey &&
        workFlowData.dateFilter?.filterKey?.length
      ) {
        query = { ...query, dateFilterKey: workFlowData.dateFilter?.filterKey };
      }
      const searchFilters: any = [];

      for (const key in selectedOptions) {
        if (Array.isArray(selectedOptions[key])) {
          if (selectedOptions[key].length > 0) {
            selectedOptions[key].forEach((item: any) => {
              const filterObject: any = {};
              filterObject[key] = item.value;
              searchFilters.push(filterObject);
            });
          }
        } else if (selectedOptions[key] && selectedOptions[key].value) {
          const filterObject: any = {};
          filterObject[key] = selectedOptions[key].value;
          searchFilters.push(filterObject);
        }
      }

      if (reset !== true) {
        if (searchFilters.length) {
          query = { ...query, searchFilters: searchFilters };
        }
      }

      let response: any = await appRequest(
        "workflow",
        "getWorkflowsCount",
        query
      );
      if (response && response.data) {
        {
          if (Array.isArray(response.data)) {
            setTotalGroupedData(response?.data);
            let groupedData: any = {};

            response.data.forEach((doc: any) => {
              Object.values(doc).forEach((entry: any) => {
                if (
                  entry &&
                  entry._id &&
                  entry._id.user.includes(accountDetails.username)
                ) {
                  const status = entry._id.status;
                  if (!groupedData[status]) {
                    groupedData[status] = 0;
                  }
                  groupedData[status] += entry.count;
                }
              });
            });
            setApprovedData(groupedData.approved || 0);
            setPendingData(groupedData.pending || 0);
            setRejectedData(groupedData.rejected || 0);
            setPassedData(groupedData.passed || 0);
            setExceptionalData(groupedData.exceptional || 0);
            setGuestHouseData(groupedData.guestHouse || 0);
            setUndefinedData(groupedData.undefined || 0);
            setPaymentFailedData(groupedData.paymentFailed || 0);
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the dashboard details`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setLoading(false);
      setSearchFilters([]);
    }
  }

  useEffect(() => {
    if (workFlowData?.dashboardType === "multiple") {
      getUsersWorkFlows();
    } else {
      getLevelData();
    }
  }, [workFlowData, activeWorkflow, selectedTransport]);

  useEffect(() => {
    if (workFlowData && workFlowData.filters) {
      console.log("workFlow", workFlowData.filters);
      let filterWorkflowFilter: any = workFlowData?.filters.filter(
        (item: any) => item.isActive === true
      );
      const options = filterWorkflowFilter.map((filter: any) => ({
        label: filter.label,
        placeholder: filter.placeholder,
        isMultiSelect: filter.isMultiSelect,
        key: filter.key,
        options: filter.filters
          .filter((nestedFilter: any) => nestedFilter.isActive)
          .map((nestedFilter: any) => ({
            _id: nestedFilter.key,
            value: nestedFilter.key,
            label: nestedFilter.label,
          })),
      }));
      setTransformedOptions(options);
    }
  }, [workFlowData]);

  const handleDropdownChange = (value: any, label: string) => {
    setSelectedOptions((prev: any) => ({ ...prev, [label]: value }));
    const dropdown: any = transformedOptions.find(
      (option: any) => option.label === label
    );

    if (dropdown && dropdown.options.length) {
      setSearchFilters((prevFilters) => {
        return [
          ...prevFilters,
          { [dropdown.key]: value?.value ? value?.value : "" },
        ];
      });
    }
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleApply = () => {
    getLevelData();
  };

  useEffect(() => {
    if (workFlowData && workFlowData.approvals) {
      const tabNames: string[] = [];
      const uniqueLevels = new Set();

      const transformedApprovals = workFlowData.approvals.map(
        (approval: any) => {
          const transformedLevel = approval.level;
          return {
            ...approval,
            level: transformedLevel,
          };
        }
      );

      let dt = transformedApprovals.filter((it: any) => it.level !== "admin");
      dt.sort((a: any, b: any) => a.level.localeCompare(b.level));

      let admins = transformedApprovals.filter(
        (it: any) => it.level === "admin"
      );
      if (admins.length && accountDetails.level === "admin") {
        dt.unshift(admins[0]);
      }

      dt.forEach((approval: any) => {
        if (approval.level && !uniqueLevels.has(approval.level)) {
          uniqueLevels.add(approval.level);
          const tabName = `${approval.designation}` || `${approval.level}`;
          tabNames.push(tabName);
        }
      });

      setTransformedTab(tabNames);
    }
  }, [workFlowData, workFlowData.approvals]);

  const [userLevelIndex, setUserLevelIndex] = useState<any>();

  useEffect(() => {
    if (accountDetails) {
      if (accountDetails.level !== "admin") {
        handleChangeTabIndex(
          parseInt(accountDetails.level.split("-")[1], 10) - 1
        );
        setUserLevelIndex(parseInt(accountDetails.level.split("-")[1], 10));
      } else {
        handleChangeTabIndex(0);
        setUserLevelIndex(0);
      }
      // const newDateFrom = calculateDateFrom();
      // setFromDate(newDateFrom);
      // setStartDate(newDateFrom)
      // setToDate(() => {
      //   const tomorrow = new Date();
      //   tomorrow.setDate(tomorrow.getDate());
      //   return tomorrow;
      // });
      // setEndDate(() => {
      //   const tomorrow = new Date();
      //   tomorrow.setDate(tomorrow.getDate());
      //   return tomorrow;
      // })
    }
  }, [accountDetails]);

  const handleOpenUploadModal = () => {
    setIsUploadOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadOpen(false);
  };

  const filterAndSumCounts = (data: any[], St: string) => {
    const status = St.toLowerCase();
    return data
      .map((doc) => {
        const totalCount: any = Object.values(doc)
          .filter(
            (entry: any) =>
              entry?._id?.status === status &&
              entry?._id?.user.includes(accountDetails.username)
          )
          .reduce((sum, entry: any) => sum + (entry.count || 0), 0);

        return totalCount > 0
          ? {
            workFlowName: doc.workFlowName,
            workFlowId: doc._id,
            count: totalCount,
          }
          : null;
      })
      .filter((item) => item !== null);
  };


  const resetDataFunction = () => {
    setSearchFilters([]);
    setSelectedOptions({});
    setSelectedTransport("");
    resetDates(); // This resets global startDate/endDate
    getLevelData(true); // true = reset mode, uses default dates
  }

  return (
    <>
      {activeComponent.open === 0 && (
        <Grid gap={3} p="0">
          <Box>
            <Box>
              <Box flexWrap="wrap" mb="1.2rem" gap={{ base: 6, lg: 8 }}>
                {!workFlowData?.dateFilter?.rangePicker && (
                  <Box display={{ base: "block", md: "none" }} mb={2}>
                    <Flex gap={2} justifyContent="flex-end">
                      <Datepicker
                        label="From"
                        date={dateFrom}
                        onDateChange={setFromDate}
                      />
                      <Datepicker
                        label="To"
                        date={dateTo}
                        onDateChange={setToDate}
                      />
                    </Flex>
                  </Box>
                )}

                {isBreakpoint && (
                  <Flex
                    gap={{ base: 2, md: 4 }}
                    justifyContent={
                      accountDetails &&
                        accountDetails?.level === "level-1" &&
                        accountDetails?.role === "uploader"
                        ? "space-between"
                        : "end"
                    }
                    alignItems="space-between"
                    my={"0.5rem"}
                  >
                    <>
                      {accountDetails &&
                        accountDetails?.level === "level-1" &&
                        accountDetails?.role === "uploader" && (
                          <Button
                            bg="teal.300"
                            color="white"
                            _hover={{ bg: "teal.400" }}
                            onClick={handleOpenUploadModal}
                          >
                            {isBreakpoint ? (
                              <FaFileUpload />
                            ) : (
                              "Upload Document"
                            )}
                          </Button>
                        )}
                    </>
                  </Flex>
                )}

                <Flex
                  gap={{ base: 2, md: 4 }}
                  justifyContent={
                    accountDetails &&
                      accountDetails?.level === "level-1" &&
                      accountDetails?.role === "uploader"
                      ? "space-between"
                      : "end"
                  }
                  alignItems="space-between"
                >
                  {!isBreakpoint && (
                    <>
                      {accountDetails &&
                        accountDetails?.level === "level-1" &&
                        accountDetails?.role === "uploader" && (
                          <Button
                            bg="teal.300"
                            color="white"
                            _hover={{ bg: "teal.400" }}
                            onClick={handleOpenUploadModal}
                          >
                            {isBreakpoint ? (
                              <FaFileUpload />
                            ) : (
                              "Upload Document"
                            )}
                          </Button>
                        )}
                    </>
                  )}
                  <Flex gap={4}>
                    <Flex gap="0.5rem">
                      {workFlowData?.dateFilter?.showFilter &&
                        (workFlowData?.dateFilter?.rangePicker ? (
                          <>
                            <Box display={{ base: "none", lg: "block" }}>
                              <CustomDateRangePicker
                                onStartDateChange={handleStartDateChange}
                                onEndDateChange={handleEndDateChange}
                                dateFrom={dateFrom}
                                dateTo={dateTo}
                                months={2}
                              />
                            </Box>
                            <Box
                              display={{ base: "block", lg: "none" }}
                              w={{ base: "12.5rem" }}
                            >
                              <CustomDateRangeMobile
                                startDate={dateFrom}
                                endDate={dateTo}
                                onStartDateChange={handleStartDateChange}
                                onEndDateChange={handleEndDateChange}
                              />
                            </Box>
                          </>
                        ) : (
                          <Box display={{ base: "none", md: "block" }}>
                            <Flex gap={2}>
                              <Datepicker
                                label="From"
                                date={dateFrom}
                                onDateChange={setFromDate}
                              />
                              <Datepicker
                                label="To"
                                date={dateTo}
                                onDateChange={setToDate}
                              />
                            </Flex>
                          </Box>
                        ))}
                    </Flex>
                    <Flex alignItems="center" gap={4}>
                      <Box w="160px">
                        <Select
                          placeholder="All Categories"
                          value={selectedTransport || ""}
                          onChange={(e) => setSelectedTransport(e.target.value)}
                          size="sm"
                          borderRadius="md"
                          borderColor="teal.300"
                          bg="white"
                          fontSize="xs"
                          _hover={{ borderColor: "teal.400" }}
                          _focus={{ borderColor: "teal.500", boxShadow: "none" }}
                        >
                          <option value="cab" style={{ color: 'black' }}>Cab</option>
                          <option value="train" style={{ color: 'black' }}>Train</option>
                          <option value="bus" style={{ color: 'black' }}>Bus</option>
                          <option value="flight" style={{ color: 'black' }}>Flight</option>
                          <option value="visa" style={{ color: 'black' }}>Visa</option>
                          <option value="hotel" style={{ color: 'black' }}>Hotel</option>
                        </Select>
                      </Box>
                      <Tooltip
                        hasArrow
                        textAlign={"center"}
                        label="Search"
                        placement="left"
                      >
                        <Button
                          bg="teal.300"
                          color="white"
                          w={{ base: "auto", lg: "3rem" }}
                          _hover={{ bg: "teal.400" }}
                          onClick={() => getLevelData()}
                        >
                          <SearchIcon />
                        </Button>
                      </Tooltip>
                    </Flex>
                    <Flex
                      justifyContent="space-between"
                      gap={{ base: 2, md: 4 }}
                    >
                      <Box>
                        <Tooltip
                          hasArrow
                          textAlign={"center"}
                          label="Reset"
                          placement="left"
                        >
                          <Button
                            border="2px solid"
                            borderColor="teal.300"
                            w={{ base: "3rem", lg: "auto" }}
                            bg="white"
                            color="teal.400"
                            _hover={{ bg: "teal.300", color: "white" }}
                            onClick={() => {
                              resetDataFunction();
                            }}
                          >
                            <HiOutlineRefresh fontSize="1.2rem" />
                          </Button>
                        </Tooltip>
                      </Box>
                      {workFlowData?.filters?.filter(
                        (item: any) => item.isActive === true
                      )?.length > 0 && (
                          <Box
                            display={{ base: "none", md: "block" }}
                            w={{ base: "auto", lg: "3rem" }}
                          >
                            <MultiDropdown
                              search={{
                                visible: workFlowData?.filters?.isActive,
                                placeholder: "select type",
                              }}
                              selectedOptions={selectedOptions}
                              onDropdownChange={handleDropdownChange}
                              dropdowns={transformedOptions}
                              onApply={handleApply}
                              searchValue={search}
                              onSearchChange={handleSearchChange}
                              resetFilters={resetFilters}
                              dateFrom={dateFrom}
                              dateTo={dateTo}
                              setFromDate={setFromDate}
                              setToDate={setToDate}
                              handleGet={getLevelData}
                              isTable={false}
                            />
                          </Box>
                        )}
                    </Flex>
                  </Flex>
                </Flex>
                {workFlowData?.filters?.filter(
                  (item: any) => item.isActive === true
                )?.length > 0 && (
                    <Box
                      position="fixed"
                      top="15rem"
                      right="1rem"
                      display={{ base: "block", md: "none" }}
                      w="3rem"
                      zIndex={10}
                    >
                      <MultiDropdown
                        search={{
                          visible: workFlowData?.filters?.isActive,
                          placeholder: "select type",
                        }}
                        selectedOptions={selectedOptions}
                        onDropdownChange={handleDropdownChange}
                        dropdowns={transformedOptions}
                        onApply={handleApply}
                        searchValue={search}
                        onSearchChange={handleSearchChange}
                        resetFilters={resetFilters}
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        handleGet={getLevelData}
                        isTable={false}
                      />
                    </Box>
                  )}
              </Box>
              {loading || Object.entries(workFlowData).length === 0 ? (
                <Grid
                  templateColumns={{
                    base: "1fr",
                    md: "repeat(3, 1fr)",
                  }}
                  gap={{ base: 5, lg: 8 }}
                >
                  {[1, 2, 3].map(
                    (_, index) => (
                      <Box
                        key={index}
                        mt="0.1rem"
                        bg="gray.100"
                        boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
                        p="1.125rem 1.375rem"
                        rounded={8}
                      >
                        <Flex justifyContent={"center"}>
                          <Skeleton w={"90%"} height="15px" mb=".6px" />
                        </Flex>
                        <Flex justifyContent={"center"} mt={3}>
                          <Skeleton width={5} h={5} rounded={50} />
                        </Flex>
                      </Box>
                    )
                  )}
                </Grid>
              ) : (
                (() => {
                  const cards = [
                    {
                      title: "pending",
                      count: pendingData || 0,
                      bg: "bg-c-yellow",
                      link: () => {
                        sessionStorage.setItem("documentTab", "0");
                        setActivePage(routePath.Approvals);
                      },
                    },
                    {
                      title: "approved",
                      count: approvedData || 0,
                      bg: "bg-c-green",
                      link: () => {
                        sessionStorage.setItem("documentTab", "1");
                        setActivePage(routePath.Approvals);
                      },
                    },

                    {
                      title: "exception",
                      count: exceptionalData || 0,
                      bg: "bg-c-red",
                      link: () => {
                        const isMultiLevel = workFlowData?.levels > 1;
                        sessionStorage.setItem("documentTab", isMultiLevel ? "3" : "2");
                        setActivePage(routePath.Approvals);
                      },
                    },
                    {
                      title: "guestHouse",
                      count: guestHouseData || 0,
                      bg: "bg-c-blue",
                      link: () => {
                        const isMultiLevel = workFlowData?.levels > 1;
                        sessionStorage.setItem("documentTab", isMultiLevel ? "4" : "3");
                        setActivePage(routePath.Approvals);
                      },
                    },
                    {
                      title: "undefined",
                      count: undefinedData || 0,
                      bg: "bg-duplicate",
                      link: () => {
                        const isMultiLevel = workFlowData?.levels > 1;
                        sessionStorage.setItem("documentTab", isMultiLevel ? "6" : "5");
                        setActivePage(routePath.Approvals);
                      }
                    },
                    {
                      title: "paymentFailed",
                      count: paymentFailedData || 0,
                      bg: "bg-c-red",
                      link: () => {
                        const isMultiLevel = workFlowData?.levels > 1;
                        sessionStorage.setItem("documentTab", isMultiLevel ? "5" : "4");
                        setActivePage(routePath.Approvals);
                      }
                    },
                    {
                      title: "total",
                      count: totalInvoicesCount || 0,
                      bg: "bg-c-gray",
                      link: () => {
                        sessionStorage.setItem("documentTab", "0");
                        setActivePage(routePath.Approvals);
                      },
                    },
                  ];

                  return (
                    <Grid
                      templateColumns={{
                        base: "1fr",
                        sm: "repeat(2, 1fr)",
                        md: "repeat(4, 1fr)",
                        lg: "repeat(4, 1fr)",
                      }}
                      gap={{ base: 5, lg: 6 }}
                    >
                      {cards.map((item, index) => (
                        <DashWidget
                          key={index}
                          title={item.title}
                          count={item.count}
                          link={item.link}
                          props={{ className: item.bg, cursor: "pointer" }}
                          activeComponent={activeComponent}
                          setActiveComponent={setActiveComponent}
                        />
                      ))}
                    </Grid>
                  );
                })()




              )}
            </Box>
          </Box>

          <Text fontSize={{ base: "lg", lg: "xl" }} fontWeight="700">
            Document Analytics
          </Text>
          {loading || Object.entries(workFlowData).length === 0 ? (
            <Flex justifyContent="center" alignItems="center" mt={"10%"}>
              <Spinner color={"teal.400"} />
            </Flex>
          ) : (
            <>
              <Card
                boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
                bg="white"
                p="1rem"
                rounded={8}
              >
                <Box>
                  <Tabs
                    variant="unstyled"
                    position="relative"
                    index={tabIndex}
                    onChange={handleChangeTabIndex}
                    overflowX="auto"
                  >
                    <Box overflow="auto" className="customScrollBar">
                      <TabList>
                        {accountDetails.level === "admin"
                          ? transformedTab.map((tabName: any, index: any) => (
                            <Tab
                              key={index}
                              fontWeight="700"
                              fontSize={{ base: "1rem", md: "1.2rem" }}
                              cursor="pointer"
                              color="teal.300"
                              textTransform="capitalize"
                              rounded={4}
                              whiteSpace="nowrap"
                              _hover={{ bg: "teal.50" }}
                              _selected={{ bg: "teal.300", color: "white" }}
                            >
                              {tabName}
                            </Tab>
                          ))
                          : transformedTab.map((tabName: any, index: any) => (
                            <Tab
                              key={index}
                              fontWeight="700"
                              fontSize={{ base: "1rem", md: "1.2rem" }}
                              cursor="pointer"
                              color="teal.300"
                              rounded={4}
                              _hover={{ bg: "teal.50" }}
                              _selected={{ bg: "teal.300", color: "white" }}
                              display={
                                index <= userLevelIndex - 1
                                  ? undefined
                                  : "none"
                              }
                              textTransform="capitalize"
                            >
                              {tabName}
                            </Tab>
                          ))}
                      </TabList>
                    </Box>
                    <TabPanels>
                      {transformedTab.map((_: any, index: number) => {
                        return (
                          <TabPanel key={index} p={0}>
                            <Grid
                              templateColumns={{ lg: "1fr 2fr" }}
                              gap={{ base: 5, lg: 8 }}
                            >
                              <Flex
                                order={{ base: 1, lg: 0 }}
                                justifyContent="center"
                                h={{ md: "40vh" }}
                                w={{ base: "270px", md: "auto" }}
                                overflow="hidden"
                              >
                                <PieChart chartData={chartData} />
                              </Flex>
                              <Box
                                position="relative"
                                overflowY="auto"
                                className="customScrollBar"
                                mt={{ base: "-.5rem", lg: "unset" }}
                              >
                                <DashboardTable
                                  invoiceData={chartData}
                                  loading={loading}
                                />
                              </Box>
                            </Grid>
                          </TabPanel>
                        );
                      })}
                    </TabPanels>
                  </Tabs>
                </Box>
                <Box />
              </Card>
            </>
          )}
        </Grid>
      )}

      {/* {activeComponent.open === 1 && (
        <WorkflowTableStatus
          status={activeComponent.status}
          data={filterAndSumCounts(totalGroupedData, activeComponent.status)}
          setActiveComponent={setActiveComponent}
        />
      )} */}

      <WorkflowListModal
        isOpen={isOpen}
        onClose={handleCloseModal}
        menu={false}
      />
      <UploadDocumentModal
        isOpen={isUploadOpen}
        onClose={handleCloseUploadModal}
        type="upload"
        handleGet={getLevelData}
      />
    </>
  );
}
